import fetchPost from '@/api/http.js'

export default {
    actions: {
        queryBillData({}, data) {//查列表
            return fetchPost('/saas/shipperOrderController/queryBillData', data)
        },getRowInfo({}, data) {//查列表
            return fetchPost('/saas/shipperOrderController/queryRowInfo', data)
        },affirmOrder({}, data) {//确认账单
            return fetchPost('/saas/shipperOrderController/affirmOrder', data)
        },uploadTOdown({}, data) {//导出
            return fetchPost('/saas/shipperOrderController/uploadTOdown', data)
        }
    }
}
